import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getFriendlyErrorMessage, verifyOrderPayment } from '../lib/artTasteApi';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState({
    loading: true,
    title: 'Verifying payment',
    message: 'We are confirming your Cashfree payment with the server.',
    orderId: '',
    tone: 'info',
  });

  useEffect(() => {
    const orderId = searchParams.get('order_id');

    if (!orderId) {
      setState({
        loading: false,
        title: 'Order reference missing',
        message: 'The payment return URL did not include an order ID.',
        orderId: '',
        tone: 'error',
      });
      return;
    }

    async function loadVerification() {
      try {
        const verification = await verifyOrderPayment(orderId);
        const paid = verification.payment_status === 'paid';

        setState({
          loading: false,
          title: paid ? 'Payment confirmed' : 'Payment pending',
          message: paid
            ? 'Your order has been paid successfully and is now ready for fulfillment.'
            : (verification.payment_message || 'Your payment is not marked paid yet. Please check again in a moment.'),
          orderId,
          tone: paid ? 'success' : 'info',
        });
      } catch (error) {
        setState({
          loading: false,
          title: 'Verification failed',
          message: getFriendlyErrorMessage(
            error,
            'We could not verify your payment status. Please try again in a moment.',
          ),
          orderId,
          tone: 'error',
        });
      }
    }

    loadVerification();
  }, [searchParams]);

  return (
    <div className={`payment-status-page tone-${state.tone}`}>
      <div className="payment-status-card">
        <span className="payment-status-kicker">Art-Taste</span>
        <h1>{state.title}</h1>
        <p>{state.message}</p>
        {state.orderId ? <strong>Order ID: {state.orderId}</strong> : null}
        <div className="payment-status-actions">
          <Link to="/" className="btn-primary">
            Back to Store
          </Link>
          <Link to="/dashboard" className="btn-secondary">
            View Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
